import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 试卷管理.
 *
 * TODO (user 后续):
 *   - 三级嵌套结构 (Section → SubSection → Item) 需要树形编辑器
 *   - 随机抽题规则 (random_count, random_filter) 需要可视化配置
 *   - 当前只暴露 Paper 主表字段
 */
export const examPapersConfig: CrudConfig = {
  resource: 'exam-papers',
  title: '试卷管理',
  rowKey: 'id',
  searchFields: ['name', 'paper_type', 'is_active'],
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, hideInForm: true, readonly: true },
    { name: 'name', label: '试卷名称', type: 'text', required: true, ellipsis: true },
    { name: 'description', label: '描述', type: 'textarea', hideInTable: true },
    {
      name: 'paper_type',
      label: '试卷类型',
      type: 'select',
      width: 120,
      options: [
        { label: '标准卷', value: 'STANDARD', color: 'blue' },
        { label: '情景卷', value: 'SCENARIO', color: 'purple' },
      ],
    },
    {
      name: 'exam_mode',
      label: '考试模式',
      type: 'select',
      width: 130,
      options: [
        { label: '顺序作答', value: 'SEQUENTIAL', color: 'blue' },
        { label: '整卷作答', value: 'FULL_PAPER', color: 'cyan' },
      ],
    },
    { name: 'industry', label: '行业 ID', type: 'number', width: 100 },
    { name: 'total_score', label: '总分', type: 'number', width: 90, hideInSearch: true },
    { name: 'duration_minutes', label: '时长(分)', type: 'number', width: 100, hideInSearch: true },
    { name: 'version', label: '版本', type: 'number', width: 80, hideInSearch: true },
    { name: 'is_active', label: '启用', type: 'boolean', width: 90 },
    { name: 'created_at', label: '创建时间', type: 'datetime', width: 180, readonly: true, hideInForm: true, hideInTable: true },
  ],
};
